import type { ReactNode } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { CssBaseline, ThemeProvider } from '@mui/material'
import { NetworkProvider } from '@/app/network/NetworkProvider'
import { queryClient } from '@/app/query/queryClient'
import { AuthProvider } from '@/features/auth/AuthProvider'
import { EventServiceProvider } from '@/features/events/EventServiceProvider'
import { ProfileProvider } from '@/features/profile/ProfileProvider'
import { SyncProvider } from '@/features/registrations/SyncProvider'
import { theme } from '@/theme/theme'

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <NetworkProvider>
        <QueryClientProvider client={queryClient}>
          <AuthProvider><ProfileProvider><SyncProvider><EventServiceProvider>{children}</EventServiceProvider></SyncProvider></ProfileProvider></AuthProvider>
        </QueryClientProvider>
      </NetworkProvider>
    </ThemeProvider>
  )
}
